// extracted by mini-css-extract-plugin
export default {"input":"style_input__q7I64","search":"style_search__qBCDl","link":"style_link__n5BTB"};